var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.humanTimeString),expression:"humanTimeString"}],attrs:{"date-time":_vm.isoTimeString}},[_vm._v(_vm._s(_vm.currentTimeAgo))])}
var staticRenderFns = []

export { render, staticRenderFns }